import { gql } from 'urql';

const FetchAdvanceConsumerReportPermission = gql`
  query FetchAdvanceConsumerReportPermission {
    advanceConsumerReportPermissionScreen {
      __typename
      title
      body
      permissionRequired {
        accountId
        primaryCopy
        iconUrl
      }
    }
  }
`;

export default FetchAdvanceConsumerReportPermission;
